<!--
 * @Author: alownilow alownilow@163.com
 * @Date: 2023-08-29 14:26:30
 * @LastEditors: mengcongyong alownilow@163.com
 * @LastEditTime: 2026-09-03 12:30:00
 * @FilePath: \alownilow-web\src\App.vue
 * @Description:
 * alownilow@163.com
 *
-->
<template>
  <div class="app-root">
    <router-view />
    <footer class="site-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener"
        >黔ICP备2023007322号-3</a
      >
    </footer>
  </div>
</template>

<style lang="less">
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: #f6f8fa;
}

#app,
.app-root {
  min-height: 100vh;
  font-family: "Noto Serif SC", "Songti SC", "SimSun", serif;
}

.site-footer {
  padding: 1.5rem 1rem 2rem;
  text-align: center;
  background: #f6f8fa;

  a {
    color: #7a8691;
    font-size: 0.8rem;
    letter-spacing: 0.04em;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #3f5f6e;
    }
  }
}
</style>
